import React from 'react';

const StatCard = ({ title, value, icon, trend, variant = 'primary' }: any) => {
  return (
    <div className={`stat-card ${variant}`}>
      <div className="stat-card-header">
        <div className="stat-icon">{icon}</div>
        {trend && (
          <div className={`stat-trend ${trend.direction}`}>
            <span>{trend.direction === 'up' ? '↗' : '↘'}</span>
            <span>{trend.value}</span>
          </div>
        )}
      </div>
      <div className="stat-card-body">
        <h2>{value.toLocaleString()}</h2>
        <p>{title}</p>
      </div>
    </div>
  );
};

export default StatCard;